import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract the session_id from the URL query parameters if available
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');

    // If there's a session ID, you could log it or handle it if needed
    if (sessionId) {
      console.log('Cancelled payment session:', sessionId);
      // No need to verify with the server since this is a cancel page
    }
  }, [location.search]);

  const handleTryAgain = () => {
    navigate('/payment');
  };

  const handleReturnToDashboard = () => {
    navigate('/projects'); // Corrected from '/dashboard' to '/projects'
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
        <div className="mx-auto mb-4 w-16 h-16 flex items-center justify-center bg-yellow-100 rounded-full">
          <X className="w-10 h-10 text-yellow-500" />
        </div>
        <h1 className="text-2xl font-bold mb-4">Payment Cancelled</h1>
        <p className="text-gray-600 mb-6">
          Your payment was cancelled and your card has not been charged.
        </p>
        <div className="flex flex-col space-y-4">
          <button
            onClick={handleTryAgain}
            className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800"
          >
            Try Again
          </button>
          <button
            onClick={handleReturnToDashboard}
            className="text-gray-600 hover:text-black"
          >
            Return to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;